export const messages = {
    "shared-link.footer.link.install": "Prova {brandName} gratuitamente",
    "shared-link.footer.link.mobile": "{brandName} per dispositivi mobile",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Dati protetti",
    "shared-link.password-dialog-box.message": "Specificare la password per l'accesso ai dati condivisi",
    "shared-link.password-dialog-box.hint.password": "Password",
    "shared-link.password-dialog-box.message.invalid-password": "Password non corretta",
    "shared-link.form.button.open": "Apri",
    "shared-link.page-not-found.title": "Pagina non trovata",
    "shared-link.page-not-found.message.main": "Impossibile trovare la pagina che si stava cercando.",
    "shared-link.page-not-found.message.description": "Il collegamento potrebbe essere scaduto oppure l'indirizzo non è stato digitato correttamente.",
    "shared-link.page-not-found.message.error": "Codice errore: 404",
    "shared-link.restore-file.label.size": "Dimensioni",
    "shared-link.restore-file.button.restore": "Scarica",
    "shared-link.links-table.column.name": "Nome",
    "shared-link.links-table.column.size": "Dimensioni",
    "shared-link.links-table.action.restore": "Scarica",
    "shared-link.links-table.action.restore-all": "Scarica tutto",
    "shared-link.side-bar.selected.title:plural": "{count} elementi selezionati | {count} elemento selezionato | {count} elementi selezionati",
    "shared-link.links-table.label.size": "Dimensioni",
    "shared-link.links-table.message.empty-folder": "Questa cartella è vuota"
};
